import React from "react";
import FindImageOnUnsplash from "components/FindImageOnUnsplash";
import StoryImageSlider from "components/stories/StoryImageSlider";
import { useProfile } from "app/context";
import hasCustomImageLibrary from "app/utils/hasCustomImageLibrary";
import StoryVideo from "./StoryVideo";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import useAddTags from "../../hooks/useAddTags";
import CustomImageLibrary from "./custom-image-library/CustomImageLibrary";

const PostStoryMedia = () => {
  const { profile } = useProfile();
  const {
    organization,
    state: {
      currentBody: postStoryCurrentBody,
      currentStory,
      selectedPrompt,
      showUnsplashSearch,
      selectedImages,
      searchValue
    },
    selectedOptionsRef,
    searchBarRef,
    cleanedMediaData,
    getSelectedMediaUrl,
    handleSelectImage,
    handleFindOnUnsplash,
    handleOpenCropImage,
    handleMediaEdited,
    handleRemoveImage
  } = usePostStoryContext();
  const addTags = useAddTags({ tags: selectedOptionsRef.current });
  const currentBody = postStoryCurrentBody ? addTags(postStoryCurrentBody) : "";
  const useCustomLibrary = hasCustomImageLibrary(organization?.name);

  const findImageComponent = !useCustomLibrary
    ? (
      <FindImageOnUnsplash
        onSelectImage={handleSelectImage}
        maxHeight={470}
        search={searchValue}
        showSearch={handleFindOnUnsplash}
        searchBarRef={searchBarRef}
      />
    )
    : (
      <CustomImageLibrary
        organizationName={organization?.name as string}
        onSelectImage={handleSelectImage}
      />
    );

  return (
    <div className="RightColumn-Row PostStoryMedia">
      {showUnsplashSearch ? (
        findImageComponent
      ) : (
        <>
          {selectedImages.length === 0 ? (
            <StoryVideo currentBody={currentBody} />
          ) : (
            <StoryImageSlider
              currentBody={currentBody}
              currentStory={currentStory}
              getSelectedMediaUrl={getSelectedMediaUrl}
              images={selectedImages}
              mediaData={cleanedMediaData}
              onOpenCropImage={handleOpenCropImage}
              onMediaEdited={handleMediaEdited}
              onRemoveImage={handleRemoveImage}
              profile={profile}
              selectedPrompt={selectedPrompt}
            />
          )}
        </>
      )}
    </div>
  );
};

export default PostStoryMedia;
